export const ENV = process.env.REACT_APP_ENV as 'prod' | 'dev';
export const DOMAIN = process.env.REACT_APP_API_DOMAIN as string;
export const LANDING_DOMAIN = 'https://magiclime.site/';
export const FRONTEND_HOST = process.env.FRONTEND_HOST as string;
